<template>
  <complex-activity
      :save-enabled="false"
      :create-mode="false"
      :fluid-bottom-line="false">
  <activity-tab title = "Reports info">
    <simple-activity :show-header="false">
      <div class="justify-content-center d-flex" style="padding-left: 15px; padding-right: 15px; padding-top: 15px;">
        <b-container class="px-0 border-top m-3">
          <b-row v-for="infoRow in reports" :key="reports.securityId" class="border-left border-right" no-gutters>
            <b-col v-if="infoRow === reports[0]" class="border-right cols-6 bg-light p-2">
              Reports Class Names:
            </b-col>
            <b-col v-else-if="infoRow === reports[reports.length-1]" class="border-bottom border-right cols-6 bg-light p-2"></b-col>
            <b-col v-else class="cols-6 border-right bg-light p-2"></b-col>
            <b-col class="border-bottom cols-6 p-2">
              {{ infoRow.reportClassName }}
            </b-col>
          </b-row>
          <b-row v-for="infoRow in dynamicPermission" :key="dynamicPermission.indexOf(infoRow)" class="border-left border-right" no-gutters>
            <b-col v-if="infoRow === dynamicPermission[0]" class="border-right cols-6 bg-light p-2">
              Reports Secured Permissions:
            </b-col>
            <b-col v-else-if="infoRow === dynamicPermission[dynamicPermission.length -1]" class="border-right border-bottom cols-6 bg-light p-2"></b-col>
            <b-col v-else class="cols-6 border-right bg-light p-2"></b-col>
            <b-col class="border-bottom cols-6 p-2">
              {{ infoRow }}
            </b-col>
          </b-row>
        </b-container>
      </div>
    </simple-activity>
  </activity-tab>

    <template v-slot:bottomLine>
    </template>

    <template v-slot:footer>

    </template>
  </complex-activity>

</template>

<script>
import Activity from "@/activity/Activity";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity.vue";
import ActivityTab from "@/activity/templates/layouts/tabs/ActivityTab.vue";
import ComplexActivity from "@/activity/templates/layouts/ComplexActivity.vue";
import FooterButton from "@/components/navbar/FooterButton.vue";

export default  {
  name: "ReportsConfigurationForm",
  components: {ComplexActivity, ActivityTab, SimpleActivity, FooterButton},

  methods: {
    ...Activity.methods,

    getTitle() {
      return "Reports Configuration Form";
    },
  },
  async mounted() {
    this.reports = await Rpc.Reports.getReportConfigs();
    this.dynamicPermission.push("Access To All Reports");
    for (const report of this.reports) {
      let parts = report.reportClassName.split('.');
      let firstPart = parts.slice(0,3).join('.');
      let secondPart = parts.slice(3).join('.');
      secondPart.slice(0,-1);
      let result = [firstPart, secondPart];
      report.reportClassName = result.join(' ');
      this.dynamicPermission.push(await Rpc.Reports.getDynamicPermissionLabel(report.securityId));
    }

  },
  data() {
    return {
      reports: [],
      dynamicPermission: [],
    }
  }
}
</script>

<style scoped>

</style>